import script from "./ZCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./ZCell.vue?vue&type=script&setup=true&lang=ts"

import "./ZCell.vue?vue&type=style&index=0&id=1130f08e&scoped=true&lang=scss"

import exportComponent from "D:\\全部项目\\funeral-and-interment\\publicnumber\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1130f08e"]])

export default __exports__